import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import NewDeploymentContainer from "./create/containers/NewDeploymentContainer";
import ViewDeploymentsContainer from "./view/containers/ViewDeploymentsContainer";

const DeploymentsView = () => {
  const navigate = useNavigate();

  const handleSelectAction = (path: string) => {
    navigate(`/deployments/${path}`);
  }

  return (
    <Grid container spacing={3} display="flex" style={{ marginTop: 20 }}>
      <NewDeploymentContainer onSelectAction={handleSelectAction} />
      <ViewDeploymentsContainer onSelectAction={handleSelectAction} />
    </Grid>
  )
};

export default DeploymentsView;
